import SeancesDashboard from "@/components/practitioner/Results/SeancesDashboard";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import BilanResultsTabs from "@/components/practitioner/Results/BilanResultTabs";
import ZFResultsTabs from "@/components/practitioner/Results/ZFResultTabs";
import { ExportPDFButton } from "@/components/common/ExportPDFButton";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { usePatientContext } from "@/hooks/usePatientContext";

export function ResultPatient() {
    const [activeTab, setActiveTab] = useState("reeducation");
  const { patientId } = useParams<{ patientId: string }>();
  const {patientInfo} = usePatientContext();

  const patientName = patientInfo ? `${patientInfo.firstName} ${patientInfo.lastName}` : 'Inconnu';

  const getExportFilename = (tabType: string) => {
    const currentDate = new Date().toISOString().split('T')[0];
    return `resultats-${tabType}-patient-${patientId}-${currentDate}`;
  };

  return (
    <div className="mt-11 mb-11">
      <Tabs defaultValue="reeducation" className="w-full" onValueChange={setActiveTab}>
        <div className="flex space-around-between">
        <div className="w-1/6"/>
        <TabsList className="w-3/6 text-center">
          <TabsTrigger value="bilan" className="w-1/2">
            Bilan
          </TabsTrigger>
          <TabsTrigger value="zonefrontiere" className="w-1/2">
            Zone Frontière
          </TabsTrigger>
          <TabsTrigger value="reeducation" className="w-1/2">
            Rééducation
          </TabsTrigger>
        </TabsList> 
                <div className="w-1/6 text-center">
            <ExportPDFButton
              filename={getExportFilename(activeTab)}
              buttonText="Exporter PDF"
              variant="outline"
              size="sm"
              activeTab={activeTab}
              patientName={patientName}
            />
          </div>

                </div>
        <TabsContent value="bilan" className="w-full flex justify-center">
          <BilanResultsTabs />
        </TabsContent>
        <TabsContent
          value="zonefrontiere"
          className="w-full flex justify-center"
        >
          <ZFResultsTabs />
        </TabsContent>
        <TabsContent value="reeducation" className="w-full flex justify-center">
          <SeancesDashboard />
        </TabsContent>
      </Tabs>
    </div>
    //   <div className="w-full flex justify-center h-full items-center">
    // </div>
  );
}

